module.exports = __webpack_public_path__ + "static/dcom2-768x452-fc6d56fd308e9ce687567739e8aaca48.png";